export enum DroneModel {
  Parrot = 'Parrot',
  DJI = 'DJI',
  DJI_Pilot_2 = 'DJI_Pilot_2',
  OBS_STUDIO = 'OBS_STUDIO',
  Other = 'Other',
}
